// extracted by mini-css-extract-plugin
export default {"form":"RwFRXcp9TGLUjJTNi_gG","placeHolderShimmer":"LJC20v8cbFCX7MAEfw8W"};